export default {
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    }
  },
  computed: {
    active() {
      //TODO: avoid using $parent
      return this === this.$parent.currentStep;
    }
  },
  mounted() {
    this.$root.$emit('checkout.register-step', this);
  },
  methods: {
    submit() {
      return this.$refs.form.submit();
    },
    getPreview() {
      return {
        icon: this.icon,
        label: this.label,
      };
    },
    goToStep(n) {
      this.$root.$emit('checkout.go-to-step', n);
    }
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/mixins/CheckoutStep.js